/* Theme specific JS */

/*
 * Handles opening and closing modals.
 *
 * Triger a modal by adding an anchor with the 'trigger-modal' class and
 * a data-modal-target with the id of the modal content div.
 *
 * For example:
 *
 *    <a href='#modal--foo' class='trigger-modal' data-modal-target='#modal--foo'>anchor text</a>
 *
 * The modal element should have the class 'modal' and the id specificed
 * in the trigger. It must have a clickable element with the class
 * 'close-modal' to handle closing the modal.
 *
 * For example:
 *
 *     <div class='modal' id='modal--foo'>
 *       <div class='modal-content'>
 *         <button class='close-modal'>x</button>
 *
 *         <p>Modal content goes here</p>
 *       </div>
 *     </div>
 */
$(function($) {
  $('.trigger-modal').click(function() {
    var modalTarget = $(this).data('modal-target');
    $('body').addClass('modal-open');
    $(modalTarget).addClass('open');
    var videoPath = $(this).data('video-path');
    $('.video-player').html('<iframe width="940" height="529" src="' + videoPath + '" frameborder="0" allowfullscreen></iframe>');
  });

  $('.close-modal').click(function() {
    $(this).parents('.modal').removeClass('open');
    $('body').removeClass('modal-open');
    $('.video-player iframe').remove();
  });
});

$(function($) {
  /*
   * Handles showing and hiding the search interface
   */

  var searchUI = $('.site-header__search .search__ui');

  $('.search__toggle').click(function() {
    searchUI.toggleClass('hidden');

    // focus on the search input if visible
    if (!searchUI.is(":hidden")) {
      $(searchUI).find('.search__input').focus();
    }
  });

  // close the search UI if ESC is pressed
  searchUI.on('keyup', function(evt) {
    if (evt.keyCode == 27) {
      if (!searchUI.is(":hidden")) {
        searchUI.toggleClass('hidden');
      }
    }
  });

  $('.close-search').click(function() {
    searchUI.addClass('hidden');
  });

  // Class adding and removing for Flickity carousels to prevent clicks
  // from triggering while dragging the carousel
  var $carouselSelector = $('.carousel');

  $carouselSelector.on('dragStart.flickity', function() {
    $carouselSelector.addClass('is-dragging');
  });

  $carouselSelector.on('dragEnd.flickity', function() {
    $carouselSelector.removeClass('is-dragging');
  });

  /*
   * Handles setting and applying the sticky nav class to style the
   * header when scrolling
   */

  // sticky nav var setup
  var preHeaderHeight = $('.hello-bar').height(),
      $stickyItems = $('.is-sticky'),
      stickyClass = 'sticky';

  // whenever the user scrolls check to see if the sticky class and top
  // spacing needs to be applied or removed
  $(window).scroll(function() {
    if ($(this).scrollTop() > preHeaderHeight) {
      // Only apply the sticky class and top style if not already present
      if (!$stickyItems.hasClass(stickyClass)) {
        $stickyItems.css('top', 0);
        $stickyItems.addClass(stickyClass);
      }
    } else {
      $stickyItems.removeClass(stickyClass);
      $stickyItems.css('top', 'inherit');
    }
  });

  // Handle showing and hiding more tags in a tag list
  var $tagsBtn = $('.btn--show-tags');

  // If there are hidden tags, setup the click handler for the show more
  // tags button. If there are no hidden tags, hide the button since it
  // is not needed.
  if ($('.hidden-tags').length > 0) {
    $tagsBtn.click(function() {
      var hiddenTags = $('.btn--show-tags').prev().find('.hidden-tags')

      if (hiddenTags.is(":hidden")) {
        $tagsBtn.html($tagsBtn.html().replace("More", "Less"))
        hiddenTags.slideDown();
      } else {
        $tagsBtn.html($tagsBtn.html().replace("Less", "More"))
        hiddenTags.slideUp();
      }
    });
  } else {
    $tagsBtn.hide();
  }

  // Apply `.site-nav--active` to parent dropdown nav items if a child
  // has the class
  var $dropdownNavItem = $('.site-nav--has-dropdown'),
      activeNavClass = 'site-nav--active';

  if ($dropdownNavItem.find('.' + activeNavClass).length > 0) {
    $dropdownNavItem.addClass(activeNavClass);
  }

  // Setup triggers for toggling nav submenus
  $('.site-nav--has-dropdown').click(function() {
    $(this).children('.site-nav__dropdown').toggle().closest('.site-header').toggleClass('dropdown-active');
  });

  // Smooth scroll to anchors that point to the id of a div within the
  // page. Source: https://css-tricks.com/snippets/jquery/smooth-scrolling/
  // Accounts for the height of the site header when scrolling.

  var headerPadding = 20;

  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - $('.site-header').height() - headerPadding
        }, 1000);
        return false;
      }
    }
  });

  ////
  // Functions for handling showing the cart callout based on the
  // shopper's location. If the shopper is outside of the U.S., the
  // callout is shown.

  function supportsStorage () {
    return typeof(Storage) !== "undefined";
  }

  // Handles whether or not to show the location callout based on the
  // passed in country code.
  function handleLocationCallout(countryCode) {
    if (countryCode !== 'US') {
      $('.cart-location-callout').show();
    }
  }

  function determineCountryCode() {
    if (!supportsStorage) {
      // If the browser does not support Local Storage, return early.
      return;
    }

    if ($('.cart-location-callout').length <= 0) {
      // If there is no callout element, return early.
      return;
    }

    var lsKey = "antlion_country_code",
        localStorageCountryCode = localStorage.getItem(lsKey);

    if (localStorageCountryCode !== null) {
      handleLocationCallout(localStorageCountryCode);
    } else {
      $.ajax({
        url: '//freegeoip.net/json/',
        type: 'POST',
        dataType: 'jsonp',
        success: function(location) {
          var countryCode = location.country_code;
          localStorage.setItem(lsKey, countryCode);
          handleLocationCallout(countryCode);
        },
        failure: function(result) {
          console.log('Location fetching failed. Error:');
          console.log(result);
        }
      });
    }
  };

  // Check and handle showing the callout on page load
  determineCountryCode();

  $('body').on('afterCartLoad.ajaxCart', function(evt, cart) {
    // Check and handle showing the callout when the cart is opened
    determineCountryCode();
  });
});

$(function(){
              $("#svgIncludes").load("https://s3-us-west-2.amazonaws.com/s.cdpn.io/40839/svgdefs-2_copy.svg"); 
          });